const Followme = ($window, $header) => {
  if ($window.pageYOffset >= 1) {
    $header.classList.add('--followme')

    return
  }

  $header.classList.remove('--followme')
}
const OpenNav =  ($openNavBtn, $nav) => {
  $openNavBtn.classList.add('--active')
  $nav.classList.add('--opened')
}
const CloseNav =  ($openNavBtn, $nav) => {
  $openNavBtn.classList.remove('--active')
  $nav.classList.remove('--opened')
}
const ToggleNav = ($openNavBtn, $nav) => {
  if ($openNavBtn.classList.contains('--active')) {
    CloseNav($openNavBtn, $nav)

    return
  }

  OpenNav($openNavBtn, $nav)
}

const MainNav = () => {
  const $header = document.querySelector('header')
  const $openNavBtn = document.querySelector('.open-nav')
  const $nav = $header.querySelector('nav')

  $openNavBtn.addEventListener('click', e => {
    e.preventDefault()
    e.stopPropagation()

    ToggleNav(e.currentTarget, $nav)
  })

  $nav.addEventListener('click', e => {
    e.stopPropagation()
  })

  Followme(window, $header)

  window.addEventListener('scroll', e => {
    Followme(window, $header)
  })

  document.addEventListener('click', () => {
    if ($openNavBtn.classList.contains('--active')) {
      CloseNav($openNavBtn, $nav)

      return
    }
  })
}

export default MainNav
